export const pinCodeFields = [
  { title: 'new_pin_code', value: '' },
  { title: 'repeat_pin_code', value: '' },
]

export const errorColor = '#f44336'
